export class OvalityService{

  calculateCtiOvalityPercent(outerDiameterMax: number, OuterDiameterMin: number, nominal: number): number {
    const ctiOvality = (outerDiameterMax - OuterDiameterMin) / nominal;
    return ctiOvality;
  }
}

export default OvalityService;